// HUD overlay draw commands (top/bottom bars, meters, pause/quit).

import { G, rooms } from '../core/state';
import { SCREEN_W, SCREEN_H, S } from '../core/constants';
import { DrawRect, draw_text } from '../render/surface';
import { drawHudMeters, drawHudStats } from './scene-hud-meters';

const tr = Math.trunc;

export function drawHudScene(t: number): void {
  DrawRect(0, 0, SCREEN_W, S(29), 0);
  DrawRect(S(1), S(1), S(638), S(27), 32);
  DrawRect(S(2), S(2), S(636), S(25), 64);

  if (!G.tele_select) {
    drawHudStats();
    drawHudMeters(t);
  } else {
    draw_text(S(80), S(11) - S(6), 'Use the movement keys to locate a checkpoint. Press ENTER to', 240);
    draw_text(S(52), S(11) + S(6), 'teleport to this checkpoint. Press ESCAPE or TAB once you are done.', 240);
  }

  if (!G.training) {
    let lifebuf = String.fromCharCode(30);
    if (G.player_lives <= 99) {
      if (G.player_lives < 10) lifebuf += ` ${G.player_lives}`;
      else lifebuf += `${G.player_lives}`;
    } else {
      lifebuf += '**';
    }
    draw_text(S(615), S(4), lifebuf, 200);
    DrawRect(S(615), S(13), S(24), S(4), 240);
    DrawRect(S(616), S(14), S(22), S(2), 0);
    const i = tr((G.player_lives_part * S(22)) / 88);
    if (i > 0) DrawRect(S(616), S(14), i, S(2), 160 + (t % 40));
  }

  let hpbuf = '';
  if (G.player_shield !== 30) {
    for (let i = 0; i < G.player_hp; i++) hpbuf += String.fromCharCode(3);
  } else {
    for (let i = 0; i < tr(G.player_hp / 2); i++) hpbuf += String.fromCharCode(3);
    if (G.player_hp % 2 === 1) hpbuf += String.fromCharCode(2);
  }
  draw_text(S(615), S(18) - S(5) * G.training, hpbuf, 200);

  DrawRect(0, S(466), SCREEN_W, S(14), 0);
  DrawRect(S(1), S(467), S(638), S(12), 32);
  DrawRect(S(2), S(468), S(636), S(10), 64);

  if (G.game_paused && !G.map_enabled && !G.voluntary_exit) {
    for (let i = 0; i < 10; i++) {
      DrawRect(tr((SCREEN_W - S(6 * 8)) / 2) - i, tr((SCREEN_H - S(8)) / 2) - i, S(6 * 8) + S(2) * i, S(8) + S(2) * i, 64 - i * 5);
    }
    draw_text(tr((SCREEN_W - S(6 * 8)) / 2), tr((SCREEN_H - S(8)) / 2), 'Paused', 255);

    const t_seconds = tr(G.expired_ms / 1000) % 60;
    const t_minutes = tr(tr(G.expired_ms / 1000) / 60) % 60;
    const t_hours = tr(tr(tr(G.expired_ms / 1000) / 60) / 60) % 24;
    const t_days = tr(tr(tr(G.expired_ms / 1000) / 60) / 60 / 24);
    let tbuf: string;
    if (t_days > 0) tbuf = `${t_days}d ${t_hours}h ${t_minutes}m ${t_seconds}s`;
    else if (t_hours > 0) tbuf = `${t_hours}h ${t_minutes}m ${t_seconds}s`;
    else tbuf = `${t_minutes}m ${t_seconds}s`;
    draw_text(SCREEN_W - S(2) - tbuf.length * S(8), S(470), tbuf, 255);
  }

  if (G.voluntary_exit) {
    DrawRect(S(152), S(200), S(336), S(80), 128);
    DrawRect(S(160), S(208), S(320), S(64), 64);
    draw_text(tr((SCREEN_W - S(30 * 8)) / 2), tr((SCREEN_H - S(8)) / 2) - S(4), 'Are you sure you want to quit?', 255);
    draw_text(tr((SCREEN_W - S(23 * 8)) / 2), tr((SCREEN_H - S(8)) / 2) + S(4), 'Press enter to confirm.', 255);
  }
}
